import React, { useEffect, useState } from "react";
import { Slang } from "../../helpers";
import { HeroSm, NavBar } from "../../components";
import { Footer } from "../../layouts";
import Loader from "../../components/loader";
import { Link } from "react-router-dom";

const EmailVerified = () => {
  const [loadPage, setLoadPage] = useState(true);

  useEffect(() => {
    let tim1 = setTimeout(() => {
      setLoadPage(false);
    }, 100);

    return () => {
      clearInterval(tim1);
    };
  }, []);
  return <>{loadPage ? <Loader /> : <Main />}</>;
};

export default EmailVerified;

const Main = () => {
  const lang = Slang("emailVerified");
  return (
    <>
      <NavBar />
      <HeroSm title={lang("title")} />
      <main id="content" role="main">
        <div className="container content-space-6 content-space-t-lg-1 content-space-b-lg-3">
          <div className="py-4">
            <div className=" text-center">
              <h3>{lang("t1")}</h3>
            </div>
            <div className="d-flex justify-content-center mt-4">
              <Link
                className="btn btn-primary btn-transition"
                to={`/login`}
              >
                {lang("t4")}
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};
